// src/com/file_of_report/DeliveryReportDef.js
// 출고실적 레포트 정의
// 운송사는 해당 없음.

import { AppWord, TableColumnType } from "../../value/AppConst";
import ValueMisc from "../../value/ValueMisc";

const DeliveryReportMetaForAccustom = {
    instructions: {
        title: '출고실적 Report(상온)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FF66CCFF', // light blue (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const DeliveryReportMetaForFresh = {
    instructions: {
        title: '출고실적 Report(신선)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FF33FF33', // light green (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

const DeliveryReportMetaForExpress = {
    instructions: {
        title: '출고실적 Report(Exp.)',
        headerRowSpan: 3,
        headerRows: [],
        headerBackgroundColor: 'FFFFC0CB', // light pink (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

export const DeliveryReportMeta = {
    fresh: DeliveryReportMetaForFresh,
    express: DeliveryReportMetaForExpress,
    accustom: DeliveryReportMetaForAccustom,
};

// width는 8의 배수가 좋아. 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160, 168..


// 출고실적레포트 (Express)
const DeliveryReportExcelColumnsForExpress = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'comName', width: 168, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'bindText', width: 240, label: '동적', option:{type:TableColumnType.TEXT} },
    { id: 'note', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'bol1', width: 184, label: 'BOL1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [
            {label:'BOL', colSpan:4},
            {label:'당일', colSpan:3}
        ]
    },
    {
        id: 'bol2', width: 184, label: 'BOL2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'bol3', width: 184, label: 'BOL3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'unsoldBol', width: 184, label: '전일', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'loadCount', width: 72, label: '당일상차', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'상차수량', colSpan:3}]
    },
    {
        id: 'unsoldCount', width: 72, label: '전일미출고', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'loadCountTotal', width: 72, label: '합계', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'sealNo1', width: 72, label: 'No1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'Seal Number', colSpan:3}],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo2', width: 72, label: 'No2', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo3', width: 72, label: 'No3', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getTemp_f()) + "</td>\n");	//전면온도
    {
        id: 'tempF', width: 72, label: '전면',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'출발기준온도', colSpan:3}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getTemp_m()) + "</td>\n");	//중면온도
    {
        id: 'tempM', width: 72, label: '중면',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getTemp_r()) + "</td>\n");	//후면온도
    {
        id: 'tempR', width: 72, label: '후면',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_f_dolly()) + "</td>\n");	//전면
    {
        id: 'eFDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'전면', colSpan:5}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_f_dollycart()) + "</td>\n");
    {
        id: 'eFDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_f_roll()) + "</td>\n");
    {
        id: 'eFRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_f_pal_kpp()) + "</td>\n");
    {
        id: 'eFPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_f_pal_aju()) + "</td>\n");
    {
        id: 'eFPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_m_dolly()) + "</td>\n");	//중면
    {
        id: 'eMDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'중면', colSpan:5}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_m_dollycart()) + "</td>\n");
    {
        id: 'eMDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_m_roll()) + "</td>\n");
    {
        id: 'eMRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_m_pal_kpp()) + "</td>\n");
    {
        id: 'eMPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_m_pal_aju()) + "</td>\n");
    {
        id: 'eMPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_r_dolly()) + "</td>\n");	//후면
    {
        id: 'eRDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'후면', colSpan:5}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_r_dollycart()) + "</td>\n");
    {
        id: 'eRDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_r_roll()) + "</td>\n");
    {
        id: 'eRRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_r_pal_kpp()) + "</td>\n");
    {
        id: 'eRPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_r_pal_aju()) + "</td>\n");
    {
        id: 'eRPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app("<td width='150' align='left'>" + CommonUtils.formatNum(voo.getE_t_dolly()) + "</td>\n");	//TOTAL
    {
        id: 'expressDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'TOTAL', colSpan:5}]
    },
    // app("<td width='150' align='left'>" + CommonUtils.formatNum(voo.getE_t_dollycart()) + "</td>\n");
    {
        id: 'expressDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + CommonUtils.formatNum(voo.getE_t_roll()) + "</td>\n");
    {
        id: 'expressRoll', width: 72, label: 'R/C',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + CommonUtils.formatNum(voo.getE_t_pal_kpp()) + "</td>\n");
    {
        id: 'expressPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Pallet', colSpan:2}]
    },
    // app("<td width='150' align='left'>" + CommonUtils.formatNum(voo.getE_t_pal_aju()) + "</td>\n");
    {
        id: 'expressPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_cigar()) + "</td>\n");	//물류집기2
    {
        id: 'eCigar', width: 72, label: '담배',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기2', colSpan:7}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_corn() ) + "</td>\n");
    {
        id: 'eCorn', width: 72, label: '양곡',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_pulp()) + "</td>\n");
    {
        id: 'ePulp', width: 72, label: '제지류',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_mu()) + "</td>\n");	
    {
        id: 'eMu', width: 72, label: 'MU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_jum_dolly()) + "</td>\n");
    {
        id: 'eJumDolly', width: 72, label: 'Dolly',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'점간대출', colSpan:3}]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_jum_dollycart()) + "</td>\n");
    {
        id: 'eJumDollycart', width: 72, label: 'Dolly Cart',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app("<td width='150' align='left'>" + String.valueOf(voo.getE_jum_roll()) + "</td>\n");
    {
        id: 'eJumRoll', width: 72, label: 'Roll Cage',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    //--------------익스프레스 센터  아래는 기본 공통적용 사항 (상차작업자,특이사항) 정보 -----//
    // app("<td width='150' align='left'>" + CommonUtils.null_chk(voo.getLoad_staff_name()) + "</td>\n");
    { id: 'loadStaffName', width: 150, label: '상차작업자', option:{type:TableColumnType.TEXT} },
    // app("<td width='150' align='left'>" + CommonUtils.null_chk(voo.getMemo()) + "</td>\n");
    { id: 'memo', width: 150, label: '특이사항', option:{type:TableColumnType.TEXT} },
];

// 출고실적레포트 (신선)
const DeliveryReportExcelColumnsForFresh = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT} },
    { id: 'note', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'bol1', width: 184, label: 'BOL1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [
            {label:'BOL', colSpan:4},
            {label:'당일', colSpan:3}
        ]
    },
    {
        id: 'bol2', width: 184, label: 'BOL2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'bol3', width: 184, label: 'BOL3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'unsoldBol', width: 184, label: '전일', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'loadCount', width: 72, label: '당일상차', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'상차수량', colSpan:3}]
    },
    {
        id: 'unsoldCount', width: 72, label: '전일미출고', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'loadCountTotal', width: 72, label: '합계', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'sealNo1', width: 72, label: 'No1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'Seal Number', colSpan:3}],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo2', width: 72, label: 'No2', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo3', width: 72, label: 'No3', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'tempF', width: 72, label: '전면',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'출발기준온도', colSpan:3}]
    },
    {
        id: 'tempM', width: 72, label: '중면',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'tempR', width: 72, label: '후면',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_f_pal_kpp()) + "</td>\n");	//전면
    {
        id: 'fFPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'전면', colSpan:6}, {label:'Pallet', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_f_pal_aju()) + "</td>\n");
    {
        id: 'fFPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_f_shr_full()) + "</td>\n");
    {
        id: 'fFShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_f_shr_half()) + "</td>\n");
    {
        id: 'fFShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_f_etc_kpp()) + "</td>\n");
    {
        id: 'fFEtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_f_etc_aju()) + "</td>\n");
    {
        id: 'fFEtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_m_pal_kpp()) + "</td>\n");	//중면
    {
        id: 'fMPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'중면', colSpan:6}, {label:'Pallet', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_m_pal_aju()) + "</td>\n");
    {
        id: 'fMPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_m_shr_full()) + "</td>\n");
    {
        id: 'fMShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_m_shr_half()) + "</td>\n");
    {
        id: 'fMShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_m_etc_kpp()) + "</td>\n");
    {
        id: 'fMEtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_m_etc_aju()) + "</td>\n");
    {
        id: 'fMEtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_r_pal_kpp()) + "</td>\n");	//후면
    {
        id: 'fRPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'후면', colSpan:6}, {label:'Pallet', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_r_pal_aju()) + "</td>\n");
    {
        id: 'fRPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_r_shr_full()) + "</td>\n");
    {
        id: 'fRShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_r_shr_half()) + "</td>\n");
    {
        id: 'fRShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_r_etc_kpp()) + "</td>\n");
    {
        id: 'fREtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_r_etc_aju()) + "</td>\n");
    {
        id: 'fREtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_pal_kpp()) + "</td>\n");	//total
    {
        id: 'freshPalKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'TOTAL', colSpan:7}, {label:'Pallet', colSpan:3}]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_pal_aju()) + "</td>\n");
    {
        id: 'freshPalAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_pal_kpp_aju()) + "</td>\n");
    {
        id: 'freshPalKppAju', width: 72, label: '합계',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_shr_full()) + "</td>\n");
    {
        id: 'freshShrFull', width: 72, label: 'Full',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Shroud', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_shr_half()) + "</td>\n");
    {
        id: 'freshShrHalf', width: 72, label: 'Half',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_etc_kpp()) + "</td>\n");
    {
        id: 'freshEtcKpp', width: 72, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'기타', colSpan:2}]
    },
    // app(" <td width='150' align='left'>" + CommonUtils.formatNum(voo.getF_t_etc_aju()) + "</td>\n");
    {
        id: 'freshEtcAju', width: 72, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_njc()) + "</td>\n");
    {
        id: 'fNjc', width: 72, label: 'NJC',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'물류집기2', colSpan:3}]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_ucolor()) + "</td>\n");
    {
        id: 'fUcolor', width: 72, label: '우든칼라',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // app(" <td width='150' align='left'>" + String.valueOf(voo.getF_octagon()) + "</td>\n");
    {
        id: 'fOctagon', width: 72, label: '옥타곤',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    //-------------- 신선센터 아래는 기본 공통적용 사항 (상차작업자,특이사항) 정보 -----//
    // app(" <td width='150' align='left'>" + CommonUtils.null_chk(voo.getLoad_staff_name()) + "</td>\n");
    { id: 'loadStaffName', width: 120, label: '상차작업자', option:{type:TableColumnType.TEXT} },
    // app(" <td width='150' align='left'>" + CommonUtils.null_chk(voo.getMemo()) + "</td>\n");
    { id: 'memo', width: 120, label: '특이사항', option:{type:TableColumnType.TEXT} },
];

// 출고실적레포트 (상온)
const DeliveryReportExcelColumnsForAccustom = [
    { id: 'planDate', width: 96, label: '출고일자', option:{type:TableColumnType.DATE} },
    { id: 'storeId', width: 56, label: '점포ID', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'storeName', width: 96, label: '점포명', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'transType', width: 88, label: '배차구분', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'vehTypeName', width: 104, label: '차종', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 136, label: '차량번호', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'driverName', width: 96, label: '기사명', option:{align: AppWord.CENTER, type:TableColumnType.TEXT} },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'bindText', width: 200, label: '동적', option:{type:TableColumnType.TEXT} },
    { id: 'note', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
    {
        id: 'bol1', width: 184, label: 'BOL1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [
            {label:'BOL', colSpan:4},
            {label:'당일', colSpan:3}
        ]
    },
    {
        id: 'bol2', width: 184, label: 'BOL2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'bol3', width: 184, label: 'BOL3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null, null]
    },
    {
        id: 'unsoldBol', width: 184, label: '전일', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'loadCount', width: 72, label: '당일상차', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [{label:'상차수량', colSpan:3}]
    },
    {
        id: 'unsoldCount', width: 72, label: '전일미출고', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'loadCountTotal', width: 72, label: '합계', // rowspan to be 2.
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    {
        id: 'sealNo1', width: 72, label: 'No1',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [{label:'Seal Number', colSpan:3}],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo2', width: 72, label: 'No2', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    {
        id: 'sealNo3', width: 72, label: 'No3', // rowspan to be 2.
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        superHeaders: [null],
        excel: (row, value) => value ? value : '0'
    },
    // //------------- 위에는 기본 공통적용  사항 정보  ---------------------//
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_pal_kpp()) + "</td>\n");
    {
        id: 'aPalKpp', width: 88, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [
            {label:'물류집기', colSpan:13},
            {label:'Pallet', colSpan:2}
        ]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_pal_aju()) + "</td>\n");
    {
        id: 'aPalAju', width: 88, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_roll_n()) + "</td>\n");
    {
        id: 'aRollN', width: 88, label: '일반',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'RollCage', colSpan:2}]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_roll_jum()) + "</td>\n");
    {
        id: 'aRollJum', width: 88, label: '점간대출',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_b2b_kpp()) + "</td>\n");
    {
        id: 'aB2bKpp', width: 88, label: 'KPP',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'B2B Pallet', colSpan:2}]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_b2b_aju()) + "</td>\n");
    {
        id: 'aB2bAju', width: 88, label: 'AJU',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // //------------- 2017-04-10일 추가작업  ---------------------//
    // // Other Pallet(특정, 점간대출, Trunking), 고가상품 (단프라, 롤케이지)
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_roll_n()) + "</td>\n");
    {
        id: 'aOpSpec', width: 88, label: '특정',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'Other Pallet', colSpan:3}]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_roll_jum()) + "</td>\n");
    {
        id: 'aOpJum', width: 88, label: '점간대출',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_b2b_kpp()) + "</td>\n");
    {
        id: 'aOpTrunc', width: 88, label: 'Trunking',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_hi_danpra()) + "</td>\n");
    {
        id: 'aHiDanpra', width: 88, label: '단프라',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, {label:'고 가 상 품', colSpan:2}]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_b2b_kpp()) + "</td>\n");
    {
        id: 'aHiRoll', width: 88, label: '롤케이지',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null, null]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_etc()) + "</td>\n");
    {
        id: 'aEtc', width: 88, label: '기타',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },
    // xlsText.append("	      <td width='150' align='left'>" + String.valueOf(voo.getA_b2b_aju()) + "</td>\n");
    {
        id: 'aTray', width: 88, label: 'Tray',
        option:{type:TableColumnType.INTEGER},
        superHeaders: [null]
    },

    // //--------------아래는 기본 공통적용 사항 (상차작업자,특이사항) 정보 -----//
    // xlsText.append("	      <td width='150' align='left'>" + CommonUtils.null_chk(voo.getLoad_staff_name()) + "</td>\n");
    { id: 'loadStaffName', width: 150, label: '상차작업자', option:{type:TableColumnType.TEXT} },
    // xlsText.append("	      <td width='150' align='left'>" + CommonUtils.null_chk(voo.getMemo()) + "</td>\n");
    { id: 'memo', width: 150, label: '특이사항', option:{type:TableColumnType.TEXT} },
];

export const DeliveryReportExcelColumns = {
    express: DeliveryReportExcelColumnsForExpress,
    accustom: DeliveryReportExcelColumnsForAccustom,
    fresh: DeliveryReportExcelColumnsForFresh,
};